import React from 'react'
import { useNavigate } from 'react-router-dom'
import TeslaWidget from '../TeslaWidget'
import './teslawidget.css'
const TeslaWidgetContainer = () => {
    const navigate = useNavigate()
  return (
      <section className='tesla-widget-container'>
          <div className="videoframe-text-container" data-aos="fade-up">
              <h1>Market  <span className="highlight">Data </span></h1>
              <p>Grab an overview of global markets including price changes, open, high, low, and close values for selected instruments.</p>
        </div>
          <div className="tesla-widget-wrapper">
              <div className="tesla-widget-text-container" data-aos="fade-up">
                  <h1>Symbol <span className="highlight">Overview</span> </h1>
                  <p>Embed the latest quotes, plus a simple chart of a single symbol of your choice. A great option for any web or mobile-geared pages.</p>
                  <div className="tesla-widget-btn-container">
                      <button className='launch-btn'
                    initial={{y:45, opacity:0}}
                    animate={{y:0, opacity:1}}
                    transition={{duration:0.65,delay:0.6}}
                    onClick={()=>{
                        navigate('/signup')
                    }}
                >
                    <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"></path><path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor"></path></svg>
                    <span>start trading</span>
                </button>
                  </div>
              </div>
              <div className="tesla-widget-chart-container">
                  <TeslaWidget />
              </div>
          </div>
    </section>
  )
}

export default TeslaWidgetContainer